module.exports = __webpack_public_path__ + "img/home_final_lazy.9502d8ac.jpg";